"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchGroupsForm = exports.SearchGroupsFormPropKeys = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var SearchInput_1 = require("./SearchInput");
exports.SearchGroupsFormPropKeys = ["searchGroupName", "setSearchGroupName"];
var SearchGroupsForm = function (state) { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Group, { widths: "equal", children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "group" }), i18n_1.default.search] }), (0, jsx_runtime_1.jsx)(SearchInput_1.SearchInput, { value: state.searchGroupName, onChange: function (e, _a) {
                        var value = _a.value;
                        return state.setSearchGroupName(value);
                    } })] }) }) })); };
exports.SearchGroupsForm = SearchGroupsForm;
